import { config } from '@uhg-abyss/web/tools/config';
import { http } from '../../tools/http';
import { formatter } from '../../tools/formatter';
import { getFeature } from '../../tools/features';

export const unitedHealthOneSSORequest = async (payload) => {
  const isStargate = getFeature('US4286561_ELIGIBILITY_STARGATE_MIGRATION');
  const isFederateOn = getFeature('US4286561_ELIGIBILITY_STARGATE_FEDERATE');
  let requestURL;

  if (
    payload.sso === 'uhone-claims' ||
    payload.sso === 'uhone-Claim search' ||
    payload.sso === 'uhone-CRP' ||
    payload.sso === 'uhone-Claim submission'
  ) {
    requestURL = `${config(
      'ELINK_CORE_STARGATE_API_URL'
    )}/api/appservices/ping-federate`;
  } else if (payload.sso === 'uhone-eligibility') {
    requestURL =
      isStargate && isFederateOn
        ? `${config(
            'ELINK_CORE_STARGATE_API_URL'
          )}/api/appservices/ping-federate/uhone`
        : `${config('ELINK_SERVICES_API_URL')}/api/ping-federate/uhone`;
  }

  const { data } = await http({
    id: 'uhone-sso-token',
    resource: 'utility',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    method: 'GET',
    url: requestURL,
    withCredentials: true,
    query: {
      uuid: payload.user.uuid,
      remoteUser: payload.user.username,
      firstName: payload.user.firstName,
      lastName: payload.user.lastName,
      email: payload.user.email,
      tin: payload.taxIdNumber,
    },
  });

  return {
    token: data.openToken || data,
    partner: config('UHONE_PING_FEDERATE_PARTNER'),
    target: config('UHONE_PING_FEDERATE_TARGET'),
  };
};

export const paanSSOTokenRequest = async (payload) => {
  const isStargate = getFeature('US4286561_ELIGIBILITY_STARGATE_MIGRATION');
  const isFederateOn = getFeature('US4286561_ELIGIBILITY_STARGATE_FEDERATE');
  const { user } = payload;

  const { data } = await http({
    id: 'paan-sso-token',
    resource: 'utility',
    method: 'POST',
    withCredentials: true,
    url:
      isStargate && isFederateOn
        ? `${config(
            'ELINK_CORE_STARGATE_API_URL'
          )}/api/appservices/ping-federate/paan`
        : `${config('ELINK_SERVICES_API_URL')}/api/ping-federate/paan`,
    body: {
      uuid: user.admin ? user.admin.uuid : user.uuid,
      emulatedUserUUID: user.admin ? user.uuid : '',
      isSuperUser: payload.isSuperUser ? 'true' : 'false',
      transactionType: '',
      provMPIN: payload.servicingProviderMpin,
      provTaxID: payload.taxIdNumber,
      provFName: payload.servicingProviderFirstName || '',
      provLName: payload.servicingProviderLastName || '',
      provBName: !payload.servicingProviderFirstName
        ? payload.servicingProviderLastName
        : '',
      mbrID: payload.memberId,
      mbrDOB: formatter('date', payload.dateOfBirth, 'yyyy-MM-dd'),
      mbrPolicyNbr: payload.groupNumber,
      mbrFirstName: payload.firstName,
      mbrLastName: payload.lastName,
      mbrState: payload.state,
      mbrZipCode: payload.zipCode,
      activeAsOfDate: payload.searchStartDate || payload.searchEndDate,
      deepLinkInfo: payload.DeepLinkInfo || '',
    },
  });
  console.log('ENV: ', payload);
  const ENV = payload.env || 'default';
  const targets = {
    default: config('PING_FEDERATE_PAAN_TARGET'),
    nonprod_specified: config(`PING_FEDERATE_PAAN_${ENV}_TARGET`),
  };
  const target =
    ENV !== 'default' ? targets.nonprod_specified : targets.default;
  console.log('SSO TARGET: ', target);
  return {
    token: data,
    partner: config('PING_FEDERATE_PAAN_PARTNER'),
    target,
  };
};

export const paanDetailsSSOTokenRequest = async (payload) => {
  const { data } = await http({
    id: 'paan-details-sso-token',
    resource: 'utility',
    method: 'GET',
    withCredentials: true,
    url: `${config('TRACKIT_PAAN_URL')}/api/ping-federate/paan`,
    query: {
      UUID: payload.user.uuid,
      userId: payload.user.username,
      userFirst: payload.user.firstName,
      userLast: payload.user.lastName,
      emailAddress: payload.user.email,
      emulatedUserUUID: '',
      sourceApplicationId: payload.sourceApplicationId,
      provTaxID: payload.provTaxID,
      provMPIN: payload.provMPIN,
      sourceApplicationSubjectAttribute:
        payload.sourceApplicationSubjectAttribute,
      provBName: payload.provBName || '',
      provFName: payload.provFName || '',
      provLName: payload.provLName || '',
    },
  });
  return {
    token: data,
    partner: config('PING_FEDERATE_PAAN_TRACKIT_PARTNER'),
    target: config('PAAN_CASE_DETAILS_TARGET'),
  };
};

export const mbmSSOTokenRequest = async (payload) => {
  const isStargate = getFeature('US4286561_ELIGIBILITY_STARGATE_MIGRATION');
  const isFederateOn = getFeature('US4286561_ELIGIBILITY_STARGATE_FEDERATE');
  const { user } = payload;

  const { data } = await http({
    id: 'mbm-sso-token',
    resource: 'utility',
    method: 'POST',
    withCredentials: true,
    url:
      isStargate && isFederateOn
        ? `${config(
            'ELINK_CORE_STARGATE_API_URL'
          )}/api/appservices/ping-federate/paan`
        : `${config('ELINK_SERVICES_API_URL')}/api/ping-federate/paan`,
    body: {
      emulatedUserUUID: user.admin ? user.uuid : '',
      isSuperUser: payload.isSuperUser ? 'true' : 'false',
      optumId: user.optumId,
      provBName: payload.servicingProviderFirstName
        ? payload.servicingProviderLastName
        : '',
      provFName: payload.servicingProviderFirstName || '',
      provLName: payload.servicingProviderLastName || '',
      provMPIN: payload.servicingProviderMpin,
      providerNPI: payload.servicingProviderNPI || '',
      provTaxID: payload.taxIdNumber,
      userFName: user.firstName,
      userLName: user.lastName,
      uuid: user.admin ? user.admin.uuid : user.uuid,
    },
  });
  return {
    token: data,
    partner: config('PING_FEDERATE_MBM_PARTNER'),
    target: config('PING_FEDERATE_MBM_TARGET'),
  };
};
